import { useState, useEffect } from "react";
import AIheader from '../../RentAI/AIheader';
import Footer from '../../../Component/Footer/Footer';
import BetaWaitlist from "../../../Component/Beta-Waitlist/BetaWaitlist";
import JoinPriorityWaitlistBtn from "../../../Component/ViralLoops/JoinPriorityWaitlistBtn";
import './MarketPlaceBlog.css';
//import BlogFaq from "../../../Component/blog/BlogFaq/BlogFaq";


const MarketPlaceBlog = ()=> {


    const [activeIndex, setActiveIndex] = useState(0);
    
    const menuItems = [
        { id: "market_place_blog_1", text: "Marketplace Infrastructure Built for Direct Rentals" },
        { id: "market_place_blog_2", text: "Hosts Are Speaking Up... And We Hear You." },
        { id: "market_place_blog_3", text: "Marketplace Power, Without the Marketplace Chains" },
        { id: "market_place_blog_4", text: "Total Control, From Booking to Business Model" },
        { id: "market_place_blog_5", text: "Ditch the Fees. Take Back the Keys." },
        // { id: "market_place_blog_6", text: "From Gray Market to Great Business" },
        // { id: "market_place_blog_7", text: "The Host-First Future Starts Now" },
    ];

    useEffect(() => {
        const handleScroll = () => {
            let scrollPosition = window.scrollY - 400; // Adjust offset for better accuracy
            let foundIndex = 0;

            menuItems.forEach((item, index) => {
                const section = document.getElementById(item.id);
                if (section) {
                    const offsetTop = section.offsetTop;
                    if (scrollPosition >= offsetTop) {
                        foundIndex = index;
                    }
                }
            });

            setActiveIndex(foundIndex);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
<AIheader/>

 
{/* START maxBannerMain */}
<section className="maxBannerMain marketPlaceBlogBannerMain">
    <div className="maxBannerOuter">
        <div className="container">
            <div className='row align-items-center'>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                    <div className='maxBannerLeft'>
                        <div className="blogHeadingInner">
                            <img width="17px" src="/img/blog/blog_icon_blue.svg" alt="icon"/>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/blogs">Blog</a></li>
                                    <img width="" src="/img/arrow-right-nav.svg" alt="arrow"/>
                                    <li className="breadcrumb-item active" aria-current="page">Article 004</li>
                                </ol>
                            </nav>
                        </div>
    
                        <h2>Thanks, Marketplaces.<br/> We’ll Take It From Here. </h2>
                        <p>Published: Apr 7, 2025</p>
                        <p><span>Estimated Reading Time: 4 mins</span></p>
                        {/* <p>Updated Mar 4, 2025</p> */}
                        <JoinPriorityWaitlistBtn buttonclass="btn btnBlue" buttonText="Get Started" />
                    </div>
                </div>
            </div>
        </div>
        <div className='maxBannerRight'>
            <figure>
                <img  src="/img/blog/marketPlaceBanner.jpg" alt="blog" />
            </figure>
        </div>
    </div>
</section>
{/* END maxBannerMain */}
 

{/* START maxBannerMain */}
<section className="choosePhotoMain">
    <div className="container">
        <div className='row'>
            <div className='col-lg-3 col-md-3 col-sm-12'>
                <div className='choosePhotoLeft'>
                    <ul>
                        {menuItems.map((item, index) => (
                            <li 
                                key={item.id} 
                                className={index === activeIndex ? "active" : ""}
                                onClick={() => setActiveIndex(index)}
                            >
                                <a href={`#${item.id}`}>{item.text}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className='col-lg-9 col-md-9 col-sm-12'>
                <div className='choosePhotoRight fleetOperatorRight'>
                    <div className='choosePhotoTop choosePhotoTopmarketplace'>
                        <img className="img-fluid marketplace_blog_1" src="/img/blog/marketplace_blog_1.jpg" alt="blog"/>
                        <p>The marketplace era is broken—and rental operators are done playing by someone else’s rules. For too long, platforms have profited off hosts while limiting their control, draining their margins, and forcing them into a one-size-fits-all system. It’s time for a platform that puts hosts first. One built for ownership, not obedience.</p>
                        <h4>TL;DR</h4>
                        <ul>
                            <li>Marketplaces lock hosts into rigid systems—charging more while offering less.</li>
                            <li>Rentid flips the script, offering a modern infrastructure without the fees, friction, or gatekeeping.</li>
                            <li>Take control of your business—pricing, policies, approvals, and strategy are yours to define.</li>
                            <li>This isn’t a platform reform—it’s a legitimate path to ownership, freedom, and scalable growth for modern rental businesses.</li>
                        </ul>
  
                    </div>

                    <div className='choosePhotoData' id='market_place_blog_1'> 
                        <h2>Marketplace Infrastructure Built for Direct Rentals</h2>
                        <p><strong>For too long, hosts have played by rules they didn’t write.</strong></p>
                        <p>Locked into rigid frameworks. Charged relentless fees. Controlled by platforms that 
                        don’t own a single car—yet dictate how your business should run. That’s not freedom. 
                        That’s not entrepreneurship. And it sure as hell isn’t the American way.</p>
                        <p><strong>At Rentid, we say: enough is enough.</strong></p>
                        <p>We’re not just disrupting the disruptors—<strong>we’re building a new path forward for car 
                        rental entrepreneurs.</strong> One that’s rooted in <strong>freedom, flexibility, and full control.</strong></p>

                    </div>

                    <div className='choosePhotoData' id='market_place_blog_2'>
                        <h2>Car Sharing Hosts Are Speaking Up...<br/> And We Hear You.</h2>
                        <img className="img-fluid marketplace_blog_2" src="/img/blog/marketplace_blog_2.png" alt="blog"/>
                        
                    </div>
 
  
                    <div className='choosePhotoData' id='market_place_blog_3'>
                        <h2>Marketplace Power Without the Marketplace Chains</h2>
                        <p>Let’s be honest. <strong>Marketplace platforms were built to protect themselves, 
                            not to empower you.</strong></p>
                        <p>Every month, more policies. More restrictions. More red tape. Their focus? Mitigate 
                            risk and maximize profit—for themselves. 
                        <strong>At Rentid, we flipped the script.</strong></p>

                        <p>We built a <strong>peer-to-peer car sharing infrastructure—but for direct car rentals.</strong> 
                            That means you get all the automation, all the digital workflows, and all the renter 
                            verification tools you’re used to—<strong>but without the fees, the control, or the manipulation.</strong></p>

                        <p><strong>This is your business. And with Rentid, it stays that way.</strong></p>
                        
                        <img className="img-fluid marketplace_blog_3" src="/img/blog/marketplace_blog_3.png" alt="blog"/>
                        <JoinPriorityWaitlistBtn buttonclass="btn btnBlue" buttonText="Get Started" />
                    </div> 

  
                    <div className='choosePhotoData' id='market_place_blog_4'>
                        <h2>Total Control, From Booking to Business Model</h2>
                        <p>Rentid is more than a platform. It’s a fully integrated back office, 
                        designed for independent operators. It handles everything from logistics, 
                        to admin, and ops—so you can focus on what matters: growing your fleet, 
                        satisfying your renters, and building your brand</p>
                        <p><strong>You control your rates. You control your rules. You control your renters.</strong></p>
                        <ul>
                            <li>Want to say no to a flaky guest? Go for it.</li>
                            <li>Want to approve bookings manually? Done. </li>
                            <li>Want to set your own cancellation or cleaning policies? Absolutely.</li>
                        </ul>
                        <p><strong>No penalties. No algorithmic punishment. No silent policy updates that hurt your margins.</strong></p>
                        <img className="img-fluid marketplace_blog_4" src="/img/blog/marketplace_blog_4.png" alt="blog"/>
                    </div>

  
                    <div className='choosePhotoData' id='market_place_blog_5'>
                        <h2>Ditch the Fees. Take Back the Keys.</h2>
                        <p><strong>This is your invitation to take your business back.</strong></p>
                        <p>Not just your revenue. Not just your operations. But <strong>your entire business strategy.</strong></p>
                        <p>Run your business based on your ambition level—and get rewarded for it.</p>
                        <p>No more invisible hands adjusting your prices. No more platform decisions that go against your better judgment. </p>
                        <p>Just you, your fleet, and <strong>a platform that exists to support you—not control you.</strong></p>
                        <img className="img-fluid marketplace_blog_5" src="/img/blog/marketplace_blog_5.png" alt="blog"/>
                        <BetaWaitlist buttonclass="btn btnBlue" buttonText="Join Rentid" />
                        <p className="marketplace_blog_5_last"><strong>Because freedom should be built into your business model—not a luxury you have to fight for.</strong></p>
                    </div>

                      
                    {/* <div className='choosePhotoData' id='market_place_blog_6'>
                        <h2>From Gray Market to Great Business</h2>
                        <p>Unlike peer-to-peer platforms that blur the legal lines and call 
                            it innovation, <strong>Rentid operates within the bounds of true entrepreneurship.</strong> 
                            You’re not operating in a gray zone. You’re building a legitimate, flexible, 
                            and fully compliant rental business—<strong>on your terms.</strong></p>
                        <p>Private rentals are no longer “underground” — <strong>They’re empowered, supported, and scalable.</strong></p>
                    </div>

                    <div className='choosePhotoData' id='market_place_blog_7'>
                        <h2>The Host-First Future Starts Now</h2>
                        <p> <strong>Rentid is the only host-first car rental platform</strong> with <strong>both marketplace 
                        and enterprise-grade solutions</strong> for real 
                        entrepreneurs. Whether you’re running one vehicle or one hundred, <strong>we built 
                        Rentid for you</strong>—not your renters, not our shareholders, and not anyone else.</p>
                        <ul>
                            <li>It’s time to ditch the middleman.</li>
                            <li>It’s time to end the marketplace trap.</li>
                            <li><strong>It’s time to take the keys—and drive your business wherever you want.</strong></li>
                        </ul>
                        <img className="img-fluid marketplace_blog_7" src="/img/blog/marketplace_blog_7.png" alt="blog"/>
                        <a className="btn btnBlue" href="#">Get Started</a>
                        <p className="marketplace_blog_7_para">Because freedom should be built into your business model—not a luxury you have to fight for.</p>
                    </div> */}
                </div>

                {/* <BlogFaq/> */}
            </div>
        </div>
    </div>
 
</section>
{/* END maxBannerMain */}


<Footer/>
        </>
    )
}

export default MarketPlaceBlog;